import { memo, useEffect, useState } from 'react';
import "./CountDown.scss";

interface CountDownProp {
  started?: boolean,
  stopped?: boolean,
  duration: number,
  timesout: () => void,
}
function CountDown(props: CountDownProp) {
  const { started, stopped, duration, timesout } = props;
  const [time, setTime] = useState(duration);

  // console.log('CountDown');
  useEffect(() => {
    if (started && !stopped) {
      // console.log('CountDown useEffect', time);
      let i: NodeJS.Timeout = setInterval(() => {
        if (0 >= time) {
          i && clearInterval(i);
          timesout();
        } else {
          setTime((o) => o - 1);
        }
      }, 1000);
      return () => {
        // console.log('CountDown useEffect return');
        clearInterval(i);
      }
    }
  }, [started, stopped, time, timesout]);

  useEffect(() => {
    setTime(duration);
  }, [started, duration]);

  return (
    <div className="count-down-wrapper">
      <div className="count-down">
        <div className="count-down-min">{Math.floor(time / 60).toString().padStart(2, "0")}</div>
        <div className="count-down-separator">:</div>
        <div className="count-down-sec">{(time % 60).toString().padStart(2, "0")}</div>
      </div>
    </div>
  );
}

CountDown.defaultProps = {
  started: true,
  stopped: false,
  duration: 60,
} as CountDownProp;

export default memo(CountDown);
